import classNames from "classnames"
import { MemberExtended } from "@nova/schemas"
import { selectWorkspaceMembers } from "features/entity-caching/members/UserManagementSlice"
import { useAppSelector } from "integrations/redux/hooks"
import { WorkspaceCollaboratorProfile } from "features/data-management/workspace/workspace/body/settings-and-collaborators/collaborators/WorkspaceCollaboratorProfile"

export const filterMentionCandidates = (members: MemberExtended[], query: string) => {
    const normalized = query.trim().toLowerCase()
    return members
        .filter(
            (member) =>
                member.fullName.toLowerCase().includes(normalized) ||
                member.email.toLowerCase().includes(normalized)
        )
        .slice(0, 5)
}

export const MentionPicker = ({
    query,
    activeIndex,
    onSelect,
}: {
    query: string
    activeIndex: number
    onSelect: (member: MemberExtended) => void
}) => {
    const members = useAppSelector(selectWorkspaceMembers)
    const matches = filterMentionCandidates(members, query)

    if (matches.length === 0) return null

    return (
        <div className="flex flex-col py-2 w-full rounded-lg border border-white-200 bg-[rgba(12,12,15,0.95)] shadow-[0px_2px_3px_0px_rgba(12,12,15,0.9),0px_4px_16px_0px_rgba(12,12,15,0.95)] overflow-hidden">
            {matches.map((member, index) => (
                <button
                    key={member.userId}
                    type="button"
                    onMouseDown={(e) => {
                        e.preventDefault()
                        onSelect(member)
                    }}
                    className={classNames(
                        "flex items-center px-3 py-1 w-full",
                        index === activeIndex ? "bg-white-200" : "hover:bg-white-200"
                    )}
                >
                    <WorkspaceCollaboratorProfile
                        userId={member.userId}
                        fullName={member.fullName}
                        email={member.email}
                        isFullWidth
                    />
                </button>
            ))}
        </div>
    )
}
